"use client";
import { StaticImageData } from "next/image";
import { Image } from "@template/components";
import * as S from "./styles.ts";
import ImageDtfiresystems from "@/lib/images/reviews/dtfiresystems.svg";
import ImageBerlitz from "@/lib/images/reviews/berlitz.svg";
import ImageFireco from "@/lib/images/reviews/fireco.svg";
import ImageHostpapa from "@/lib/images/reviews/hostpapa.svg";
import ImageThegoldenhinde from "@/lib/images/reviews/thegoldenhinde.svg";
import ImageKorukids from "@/lib/images/reviews/korukids.svg";

interface ILogosSectionComponentProps {
  heading?: string;
  logos?: {
    src: string | StaticImageData;
    alt: string;
  }[];
}

const LogosSectionComponent = ({
                                 heading,
                                 logos,
                               }: ILogosSectionComponentProps) => {
  return (
    <>
      <S.LogosWrapper>
        <S.LogosHeader>{heading}</S.LogosHeader>
        <S.LogosCarousel>
          {logos.map((logo, index) => (
            <S.Logo key={index}>
              <Image
                src={logo.src}
                alt={logo.alt}
              />
            </S.Logo>
          ))}
        </S.LogosCarousel>
      </S.LogosWrapper>
    </>
  );
};

export const YayLogosSectionComponent = (props: {
  heading: ILogosSectionComponentProps["heading"];
}) => (
  <LogosSectionComponent
    {...props}
    logos={[
      {
        src: ImageDtfiresystems,
        alt: "DT Fire Systems",
      },
      {
        src: ImageBerlitz,
        alt: "Berlitz",
      },
      {
        src: ImageFireco,
        alt: "Fireco",
      },
      {
        src: ImageHostpapa,
        alt: "HostPapa",
      },
      {
        src: ImageThegoldenhinde,
        alt: "The Golden Hinde",
      },
      {
        src: ImageKorukids,
        alt: "Koru Kids",
      },
    ]}
  />
);

export default LogosSectionComponent;

export const options = [
  {
    description: "",
    displayName: "LogosSectionComponent",
    methods: [],
    props: {
      heading: {
        required: false,
        flowType: { name: "string" },
        description: "",
      },
      logos: {
        required: false,
        flowType: {
          name: "Array",
          elements: [
            {
              name: "signature",
              type: "object",
              raw: "{\n  src: string | StaticImageData;\n  alt: string;\n}",
              signature: {
                properties: [
                  {
                    key: "src",
                    value: {
                      name: "union",
                      raw: "string | StaticImageData",
                      elements: [
                        {
                          name: "string",
                        },
                        {
                          name: "StaticImageData",
                        },
                      ],
                      required: true,
                    },
                  },
                  {
                    key: "alt",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                ],
              },
            },
          ],
          raw: "{\n  src: string | StaticImageData;\n  alt: string;\n}[]",
        },
        description: "",
      },
    },
  },
];
